import { Box } from '@mui/material';
import styled from "styled-components";

const HomeStyles = styled(Box)`
    width: 100%;

    .home {
        padding: 50px 20px 150px;
    }
`

export default HomeStyles;